import { endpoints, getDatabaseData } from './index';
import { questions } from './data/_questions-data';
import { questionsCategoryOptions } from './data/_questions-category-options';

const getQuestions = async () => {
  // const response = await getDatabaseData(endpoints.QUESTIONS).then(
  //   data => data
  // );

  return questions;
};

const getQuestionsCategoryOptions = async () => {
  // const response = await getDatabaseData(
  //   endpoints.QUESTIONS_CATEGORY_OPTIONS
  // ).then(data => data);

  return questionsCategoryOptions;
};

const getQuestionsDescriptionOptions = async () => {
  const response = await getDatabaseData(
    endpoints.QUESTIONS_DESCRIPTION_OPTIONS
  ).then(data => data);

  return response;
};

const getQuestionsPersonalityOptions = async () => {
  const response = await getDatabaseData(
    endpoints.QUESTIONS_PERSONALITY_OPTIONS
  ).then(data => data);

  return response;
};

export default {
  getQuestions,
  getQuestionsCategoryOptions,
  getQuestionsDescriptionOptions,
  getQuestionsPersonalityOptions,
};



// WEBPACK FOOTER //
// ./src/api/questions.js